export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/48d0057cf54c678c61fc778c0aeda84f.svg";